import { useEffect, useState, useMemo, useCallback } from 'react'

import { vaultsLimit } from '../data'
import useVaultsData from './useVaultsData'


type Input = Partial<VaultsPage.SortFormParams> & {
  sortForm: VaultsPage.SortForm
}

type Output = {
  vaults: VaultList.Vault[]
  blacklistTotal: number
  isFetching: boolean
  fetchNextItems: () => void
}

const useVaultsList = (values: Input): Output => {
  const { sort, filter, search, sortForm } = values

  const [ skip, setSkip ] = useState(0)

  const { data: vaults, isFetching, blacklistTotal } = useVaultsData({
    filter: filter || 'all',
    search: search || '',
    sort: sort || 'TVL',
    limit: vaultsLimit,
    skip,
  })

  useEffect(() => {
    const resetSkip = () => setSkip(0)

    sortForm.subscribe('change', resetSkip)

    return () => {
      sortForm.unsubscribe('change', resetSkip)
    }
  }, [ sortForm ])

  const fetchNextItems = useCallback(() => {
    setSkip((skip) => skip + vaultsLimit)
  }, [])

  return useMemo(() => ({
    vaults,
    isFetching,
    fetchNextItems,
    blacklistTotal,
  }), [
    vaults,
    isFetching,
    fetchNextItems,
    blacklistTotal,
  ])
}


export default useVaultsList
